/**
 * Notifications mixin
 * Provides consistent notification methods to components
 */

export const NOTIFICATION_COLORS = {
  SUCCESS: 'success',
  WARNING: 'orange', 
  ERROR: 'error',
  INFO: 'info'
}

// Map semantic types to actual colors used by snackbar component
const normalizeColor = (color) => {
  const semanticMap = {
    'warning': 'orange'
    // other mappings already match: success->success, error->error, info->info
  }
  return semanticMap[color] || color
}


export const NOTIFICATION_MESSAGES = {
  DRAFT_SAVED: 'Draft saved',
  ASSAY_FINALIZED: 'Assay finalized',
  VALIDATION_ERRORS: 'Please fix highlighted errors',
  HYDRATION_FAILED: 'Failed to hydrate existing draft:',
  MELT_ALLOCATION_RECORDED: 'Melt allocation recorded'
}

export default {
  methods: {
    /**
     * Show a notification using the global event emitter
     * @param {string} message - notification message
     * @param {string} color - notification color (success, warning, error, info)
     * @param {Object} options - additional options (for backward compatibility)
     */
    showNotification(message, color = NOTIFICATION_COLORS.SUCCESS, options = {}) {
      const payload = {
        text: message,
        color: normalizeColor(color),
        ...options
      }
      window._VMA.$emit('SHOW_SNACKBAR', payload)
    },

    /**
     * Show a success notification
     * @param {string} message - success message
     * @param {Object} options - additional options
     */
    showSuccessNotification(message, options = {}) {
      this.showNotification(message, NOTIFICATION_COLORS.SUCCESS, options)
    },

    /**
     * Show a warning notification
     * @param {string} message - warning message
     * @param {Object} options - additional options
     */
    showWarningNotification(message, options = {}) {
      this.showNotification(message, NOTIFICATION_COLORS.WARNING, options)
    },

    /**
     * Show an error notification
     * @param {string} message - error message
     * @param {Object} options - additional options
     */
    showErrorNotification(message, options = {}) {
      this.showNotification(message, NOTIFICATION_COLORS.ERROR, options)
    },

    /**
     * Show an info notification
     * @param {string} message - info message
     * @param {Object} options - additional options
     */
    showInfoNotification(message, options = {}) {
      this.showNotification(message, NOTIFICATION_COLORS.INFO, options)
    },


  }
}
